export function gcd(a, b) {
  a = Math.abs(a);
  b = Math.abs(b);
  while (b) {
    const t = a % b;
    a = b;
    b = t;
  }
  return a || 1;
}

export function simplify(p, q) {
  if (q < 0) {
    p = -p;
    q = -q;
  }
  const g = gcd(p, q);
  return [p / g, q / g];
}

export function latexFrac(p, q, display = true) {
  const [pp, qq] = simplify(p, q);
  if (qq === 1) return `${pp}`;
  return `${display ? "\\dfrac" : "\\tfrac"}{${pp}}{${qq}}`;
}

export function parseUserFraction(userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object" || !userAnswer.raw) return null;
  const s = String(userAnswer.raw).replace(",", ".").trim();
  if (/^[+-]?\d+$/.test(s)) return [parseInt(s, 10), 1];
  const m = s.match(/^\s*([+-]?\d+)\s*\/\s*([+-]?\d+)\s*$/);
  if (!m) return null;
  const p = parseInt(m[1], 10);
  const q = parseInt(m[2], 10);
  if (q === 0) return null;
  return simplify(p, q);
}

export function fractionsEqual(a, b) {
  if (!a || !b) return false;
  const [ap, aq] = simplify(a[0], a[1]);
  const [bp, bq] = simplify(b[0], b[1]);
  return ap === bp && aq === bq;
}

export function checkFractionAnswer(expected, userAnswer) {
  const parsed = parseUserFraction(userAnswer);
  if (!parsed) {
    return {
      correct: false,
      message: "Podaj ułamek, np. 1/2, albo liczbę całkowitą.",
      expected: latexFrac(expected[0], expected[1])
    };
  }
  return {
    correct: fractionsEqual(parsed, expected),
    expected: latexFrac(expected[0], expected[1])
  };
}

export function pick(items) {
  return items[Math.floor(Math.random() * items.length)];
}

export function makeUid(prefix) {
  return `${prefix}_${Date.now()}_${Math.floor(Math.random() * 1e9)}`;
}
